
import axios from "axios";

export const getClaimOrganizationList = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + `/claimableb2b`, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const downloadClaimReports = (obj, reportBody) => {
  return axios
    .get(
      process.env.REACT_APP_NOT_SECRET_CODE +
        `/claims-invoice-generation?start_date=${reportBody.start_date}&end_date=${reportBody.end_date}&organization_id=${reportBody.organization_id.value}&type=${reportBody.type.value}`,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((err, res) => {
      console.log(res);
      console.log(err);
    });
};
